import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { useTranslation } from '../../../../translations';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';

const ShopInfoText = React.forwardRef(function ShopInfoText({ info }, ref) {
  const { t } = useTranslation();
  const { getLocalizedText } = useLanguageControls();

  return <div className={'shop__info-text'}>{safeHTML(getLocalizedText(t(info.text, { returnObjects: true })))}</div>;
});

export default ShopInfoText;
ShopInfoText.propTypes = {};
